import { HttpClient } from '@angular/common/http';
import {Component, HostListener, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { SeguridadService } from './services/seguridad.service';
import { Chart } from 'chart.js';
import { Global } from 'src/global';
import { registerLocaleData } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import ChartDataLabels  from 'chartjs-plugin-datalabels';
import es from '@angular/common/locales/es';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{

    topbarTheme = 'blue';

    menuTheme = 'light';

    layoutMode = 'light';

    /**
     * Escala base del layout, en px sobre el `font-size` del `<html>`.
     *
     * No es tamaño de letra: TODO el layout está en `rem`, así que este número
     * escala proporcionalmente altos, anchos, paddings y márgenes. Es el
     * equivalente al zoom del navegador, pero aplicado solo a la aplicación.
     *
     * El template venía en 14. Se baja a 13 para que entre más contenido en
     * pantalla —entre otras cosas, más módulos en el menú horizontal— sin
     * comprometer la legibilidad de los montos. El rango sano es 12 a 16.
     */
    static readonly ESCALA_BASE = 13;

    /** Clave del modo de menú elegido por el usuario en este navegador. */
    static readonly CLAVE_MODO_MENU = `${Global.PREFIX_RECORD}.menuMode`;

    menuMode = AppComponent.leerModoMenu();

    /**
     * Modo de menú guardado, o `horizontal` si no hay nada elegido todavía.
     *
     * Solo se aceptan los dos modos que ofrece el panel. Cualquier otro valor
     * —un `localStorage` manoseado, o un modo del template que ya no exponemos—
     * cae al default en vez de dejar la aplicación en un estado que la interfaz
     * no puede revertir.
     */
    private static leerModoMenu(): string {
        const guardado = localStorage.getItem(AppComponent.CLAVE_MODO_MENU);
        return guardado === 'static' || guardado === 'horizontal' ? guardado : 'horizontal';
    }

    inlineMenuPosition = 'bottom';

    inputStyle = 'filled';

    ripple = true;

    isRTL = false;

    mostrarDialog = false;

    exit: boolean;

    idleTime: number = 0;

    maxIdleTime: number = 30;

    constructor(
        private primengConfig: PrimeNGConfig, 
        private http: HttpClient, 
        private router: Router,
        private seguridadService: SeguridadService
    ) {
        this.translatePrimeNg();
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        document.documentElement.style.fontSize = `${AppComponent.ESCALA_BASE}px`;
        Chart.register(ChartDataLabels);
        this.contarInactividad();
    }

    async contarInactividad() {
        setInterval(() => {
            const sessionActive = localStorage.getItem(`${Global.PREFIX_RECORD}.sessionActive`);
            if (sessionActive !== "true") {
                this.router.navigate(['/auth/logout']);
            }
        }, 1000);
        
        setInterval( () => {
            this.checkInactivity();
        }, 60000);

    }

    //agregar HostLiner
    @HostListener('document:mousemove', ['$event'])
    @HostListener('document:keydown', ['$event'])
    
    async onUserAction(event) { 
        if(event) {
            this.idleTime = 0;
            localStorage.setItem(`${Global.PREFIX_RECORD}.sessionActive`, "true");
        }
    }

    async checkInactivity() {
        if (this.seguridadService.getCurrentUser()) {
            this.idleTime++;    
            if (this.idleTime >= this.maxIdleTime) {
                localStorage.setItem(`${Global.PREFIX_RECORD}.sessionActive`, "false");
            }
        } else {
            this.idleTime = 0;
        }
    }

    async translatePrimeNg(): Promise<void> {
        registerLocaleData( es );
        const resp: any = await lastValueFrom(this.http.get('assets/language_es.json', {headers: {}}));
        this.primengConfig.setTranslation(resp.primeng);
    }
}
